export const HotspotsEvents = {
  HOTSPOT_CLICK: 'hotspot_click',
  HOTSPOT_DISPLAYED:  'hotspot_displayed',
}
